/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.
*/

import {
  RouteDefinition,
  useTranslationContext,
} from "@gnu-taler/web-util/browser";
import { VNode, h } from "preact";
import { CreateCashout } from "./CreateCashout.js";

export function CashoutCreatePage({
  account,
  routeClose,
  routeHistory,
  onCashout,
}: {
  account: string;
  routeClose: RouteDefinition;
  routeHistory: RouteDefinition;
  onCashout(): void;
}): VNode {
  const { i18n } = useTranslationContext();
  return (
    <section class="mt-2" aria-labelledby="cashout-heading">
      <a
        href={routeClose.url({})}
        class="inline-flex items-center text-sm font-semibold text-brand hover:underline"
      >
        <span class="mr-1" aria-hidden="true">
          ←
        </span>
        <i18n.Translate>Back to overview</i18n.Translate>
      </a>
      <div class="mx-auto mt-6 max-w-3xl">
        <div class="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h1 id="cashout-heading" class="text-2xl font-semibold text-brand">
              <i18n.Translate>Cash out</i18n.Translate>
            </h1>
            <p class="mt-2 text-sm text-gray-600">
              <i18n.Translate>
                Convert regional currency and send it to your cashout account.
              </i18n.Translate>
            </p>
          </div>
          <a
            href={routeHistory.url({})}
            class="text-sm font-semibold text-brand hover:underline"
          >
            <i18n.Translate>View previous cashouts</i18n.Translate>
          </a>
        </div>
        <CreateCashout
          account={account}
          routeClose={routeClose}
          onCashout={onCashout}
        />
      </div>
    </section>
  );
}
